import React from 'react'
import { menu2List } from 'components/Header/headerMenuConfig'

const HeaderMenu2 = () => {
  return <div className='HeaderMenu2'>{menu2List}</div>
}

export default HeaderMenu2
